import {
  SessionServerSelectors,
  SessionSiteSelectors,
  SessionUserSelectors,
} from '~src/bootstrap/redux/selectors/SessionInfoSelectors';

import { AppState } from '../../bootstrap/redux/state/AppState';
import { Messages } from '../../codegen/Localize';
import {
  EntityActionNames,
  IEntityAction,
} from '../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { runFlowTaskChangePriority } from '../actions/RunFlowTaskMenuActions';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';
import {
  ManageRunFlowTaskActions,
  userHasManageRunFlowTaskPermissions,
} from '../utils/FlowTaskActionUtils';

export const RunFlowTaskChangePriorityAction: IEntityAction<
  RunFlowTaskInfo,
  ManageRunFlowTaskActions
> = {
  name: EntityActionNames.TasksPriority,
  translateName: Messages.tasksSetPriority_action,
  isVisible: (targetItems: RunFlowTaskInfo[], state: AppState) => {
    return targetItems.length > 0;
  },
  isClickable: (
    availableActions: ManageRunFlowTaskActions,
    targetItems: RunFlowTaskInfo[],
    state: AppState,
  ) => {
    const ignoreExtractTaskPriority: boolean =
      SessionServerSelectors.ignoreExtractTaskPriority(state);

    if (ignoreExtractTaskPriority) {
      return false;
    }

    if (!userHasManageRunFlowTaskPermissions(availableActions)) {
      return false;
    }

    // Only admins (site admin or server admin) can change priority for all task types (single and linked)
    const isSiteAdmin = SessionSiteSelectors.isSessionSiteAdmin(state);
    const isServerAdmin = SessionUserSelectors.isSessionServerAdmin(state);

    return isSiteAdmin || isServerAdmin;
  },
  createReduxAction: (targetItems: RunFlowTaskInfo[]) =>
    runFlowTaskChangePriority(targetItems),
};
